import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import authService from '../services/auth';

export default function AuthCallbackPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    // Debug: log all URL params
    console.log('AuthCallbackPage - URL params:', Object.fromEntries(searchParams.entries()));
    
    // Check if we have a token in the URL (from OAuth callback)
    // The server redirects to: /auth/callback?token=...&refresh_token=...
    const token = searchParams.get('token');
    const refreshToken = searchParams.get('refresh_token');
    
    console.log('AuthCallbackPage - Token:', token ? 'Present' : 'Missing');
    console.log('AuthCallbackPage - RefreshToken:', refreshToken ? 'Present' : 'Missing');
    
    if (token) {
      // Save token and redirect to dashboard
      authService.setToken(token);
      console.log('AuthCallbackPage - Token saved, checking admin status...');
      
      // Verify user is admin
      const isAdmin = authService.isAdmin();
      const role = authService.getRole();
      console.log('AuthCallbackPage - Is Admin:', isAdmin, 'Role:', role);
      
      if (isAdmin) {
        console.log('AuthCallbackPage - Redirecting to dashboard');
        navigate('/dashboard', { replace: true });
      } else {
        console.log('AuthCallbackPage - User is not admin, showing error');
        setError('You do not have admin access. Please contact an administrator.');
        authService.logout();
      }
    } else {
      // Check for error in URL
      const urlError = searchParams.get('error');
      console.log('AuthCallbackPage - No token, error param:', urlError);
      
      if (urlError) {
        setError(`Authentication failed: ${urlError}. Please try again.`);
      } else {
        // No token in URL, check if we're already authenticated
        const isAuthenticated = authService.isAuthenticated();
        const isAdmin = authService.isAdmin();
        console.log('AuthCallbackPage - Already authenticated:', isAuthenticated, 'Is Admin:', isAdmin);
        
        if (isAuthenticated && isAdmin) {
          navigate('/dashboard', { replace: true });
        } else {
          setError('Authentication failed. No token received. Please try again.');
        }
      }
    }
  }, [navigate, searchParams]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="max-w-md w-full space-y-8 text-center">
          <div className="text-red-600">{error}</div>
          <button
            onClick={() => navigate('/login', { replace: true })}
            className="text-blue-600 hover:text-blue-800"
          >
            Go to Login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-lg">Authenticating...</div>
    </div>
  );
}

